import React, { FC, useEffect, useMemo } from 'react'
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'

import useGetRoleByID from 'components/tools/CustomForm/components/Viewer/hooks/useGetRoleByID'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import RoleCard from 'Attendances/components/RoleCard'
import SearchRoleOnCustomForm from './components/SearchRoleOnCustomForm'
import SelectRoleOnCustomForm from './components/SelectRoleOnCustomForm'
import { useCustomFormRoleSelectionDrawerManager } from './contexts/CustomFormRoleSelectionDrawerManager/Provider'

type Views = {
  [key: string]: JSX.Element
}

type Props = {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormRoleSelectionDrawerContent: FC<Props> = ({ question, disabled }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { getRole, loadingRole } = useGetRoleByID()

  const { selectedRole, setSelectedRole, view, filter } = useCustomFormRoleSelectionDrawerManager()

  const RenderComponent = useMemo(() => {
    const views: Views = {
      SEARCH_ROLE: <SearchRoleOnCustomForm onClose={onClose} />,
      SELECT_ROLE: <SelectRoleOnCustomForm onClose={onClose} />,
    }

    return views[view]
  }, [filter, view])

  async function loadRole(roleId: string) {
    const roleFromAPI = await getRole(roleId)
    setSelectedRole(roleFromAPI)
  }

  useEffect(() => {
    async function loadAsyncFunction() {
      if (question.default_value && question.default_value.length > 0) {
        const roleId = question.default_value[0]
        await loadRole(roleId)
      }
      if (question.answer && question.answer.length > 0) {
        const roleId = question.answer[0]
        await loadRole(roleId)
      }
    }
    loadAsyncFunction()
  }, [question])

  return (
    <>
      <Button
        isLoading={loadingRole}
        minWidth="100%"
        variant="outline"
        isDisabled={disabled}
        width="max-content"
        onClick={onOpen}
      >
        {selectedRole?.id ? 'Atualizar papel' : 'Adicionar papel'}
      </Button>

      {selectedRole?.id && <RoleCard roleInformation={selectedRole} borderWidth="1px" borderColor="borderColor" />}

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          {RenderComponent}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default CustomFormRoleSelectionDrawerContent
